import { createMongoAbility } from "@casl/ability";
import { createContext } from "react";
import { SpeamAction, SpeamSubject } from "../config/auth/casl";

const initialAbility = createMongoAbility<[SpeamAction, SpeamSubject]>([]);
export const AbilityContext = createContext(initialAbility);
